import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Platform } from '@ionic/angular';
import { RedirectService } from 'src/app/services/redirect/redirect.service';

export let browserRefresh: boolean = false;

@Component({
  selector: 'app-redirect',
})

export class RedirectComponent implements OnInit {

  public subscription: Subscription

  constructor(
    private redirectService: RedirectService,
    private router: Router,
    private platform: Platform
  ){
    this.subscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart){
        browserRefresh = !router.navigated;
        const route = event.url.substring(1);
        const activeRedirect: boolean = this.redirectService.getTabNames(route);
        if(browserRefresh && activeRedirect) {
          this.redirectService.browserReloadActions(route);
        }
      }
    });
  }

  ngOnInit(): void {
    this.redirectService.checkForRedirects();
    if(this.platform.is('capacitor')) {
      this.redirectService.mobileRedirectBasedOnPathName();
    } else {
      this.redirectService.navigateBasedOnPathName();
    }
  }

}
